"use client"

import { useEffect } from "react"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("GLOBAL_ERROR_BOUNDARY:", error)
  }, [error])

  return (
    <div style={{ fontFamily: "system-ui", padding: 24 }}>
      <h2 style={{ marginBottom: 8 }}>App crashed</h2>
      <pre style={{ whiteSpace: "pre-wrap" }}>{String(error?.stack || error?.message || error)}</pre>
      <button onClick={() => reset()} style={{ marginTop: 12 }}>
        Try again
      </button>
    </div>
  )
}
